@if (!dismissed()) {
  <div
    class="relative flex border rounded-lg py-2 bg-orange-50 border-orange-500 text-orange-700 text-xs"
    [class]="
      expanded()
        ? 'flex-col gap-1 w-full min-h-25 text-center px-10'
        : 'gap-3 w-fit min-h-12 px-4'
    ">
    @if (expanded()) {
      <div class="font-bold">Action needed</div>
      <div class="font-medium">
        Please complete the
        <span class="font-bold">{{ formTypeLabel() }}</span> before your
        appointment. If the form is not submitted in advance, the provider will be
        unable to see you.
      </div>
    } @else {
      <mat-icon svgIcon="info" class="my-auto text-[#D03801]!"></mat-icon>
      <div class="leading-[120%] text-left">
        <p class="font-bold">Action needed</p>
        <p class="font-medium">Fill {{ formTypeLabel() }} before appointment</p>
      </div>
    }
    <button
      type="button"
      data-testid="fill-form-btn"
      (click)="fillForm.emit(form())"
      class="border border-orange-500 rounded-lg font-medium focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-orange-100"
      [class]="
        expanded()
          ? 'mt-2 self-center py-2 px-3 inline-flex w-full sm:w-auto'
          : 'py-1.5 px-3 whitespace-nowrap'
      ">
      <span class="w-full text-center">Fill form</span>
    </button>
    <button
      type="button"
      aria-label="Dismiss"
      (click)="dismiss()"
      class="border border-orange-500 rounded-full p-1 w-7 h-7 flex items-center justify-center hover:bg-orange-100 transition-colors shrink-0"
      [class]="expanded() ? 'absolute top-2 right-2' : 'self-center'">
      <mat-icon svgIcon="close" class="w-4! h-4! text-orange-600"></mat-icon>
    </button>
  </div>
}
